<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <div class="flex flex-col gap-4">
    <p class="font-semibold">Please enter your email</p>
    <div>
      <input type="text" id="email" formControlName="email"
        class="w-3xs w-[17rem] rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden md:w-xs"
        placeholder="Enter email" />
    </div>
    <div class="relative flex items-center">
      <button
        class="cursor-pointer justify-center rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none"
        type="submit">
        Save
      </button>
      <app-embedded-alert class="ps-4" [error]="error" [success]="success"></app-embedded-alert>
    </div>
  </div>
</form>